import React, { useState, useEffect } from 'react';
import { X, Download } from 'lucide-react';

const DirectoryExportModal = ({ isOpen, onClose, sections, onExport }) => {
  const publicSections = (sections || []).filter(s => !s.is_private);
  const [selected, setSelected] = useState(() => new Set(publicSections.map(s => s.id)));

  useEffect(() => {
    if (isOpen) {
      const publicIds = (sections || []).filter(s => !s.is_private).map(s => s.id);
      setSelected(new Set(publicIds));
    }
  }, [isOpen, sections]);

  if (!isOpen) return null;

  const toggleSection = (id) => {
    setSelected(prev => {
      const n = new Set(prev);
      if (n.has(id)) n.delete(id); else n.add(id);
      return n;
    });
  };
  const selectAll = () => setSelected(new Set(publicSections.map(s => s.id)));
  const clearAll = () => setSelected(new Set());

  const handleExport = () => {
    const exportSections = publicSections.filter(s => selected.has(s.id));
    onExport(exportSections);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-[70] sm:p-4" onClick={onClose}>
      <div className="bg-white rounded-t-2xl sm:rounded-2xl max-w-md w-full shadow-2xl max-h-[85vh] flex flex-col" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 pt-5 pb-3 flex-shrink-0">
          <div>
            <h3 className="text-lg font-semibold" style={{ color: '#163248' }}>Експорт довідника</h3>
            <p className="text-xs text-gray-500 mt-0.5">Оберіть розділи для PDF</p>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-400" /></button>
        </div>

        {publicSections.length === 0 ? (
          <div className="px-5 py-10 text-center">
            <p className="text-sm text-gray-400">Нема публічних розділів для експорту</p>
            <p className="text-xs text-gray-400 mt-2">Приватні розділи не включаються в PDF</p>
          </div>
        ) : (
          <>
            <div className="flex items-center justify-between px-5 pb-2 text-xs" style={{ color: '#6b7280' }}>
              <span>Обрано <span style={{ color: '#163248', fontWeight: 600 }}>{selected.size}</span> з {publicSections.length}</span>
              <div className="flex gap-3">
                <button onClick={selectAll} className="hover:underline" style={{ color: '#f97316' }}>Вибрати всі</button>
                <button onClick={clearAll} className="hover:underline" style={{ color: '#f97316' }}>Зняти всі</button>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto px-5 py-2 space-y-1">
              {publicSections.map(s => {
                const isChecked = selected.has(s.id);
                return (
                  <label key={s.id} className={`flex items-center gap-3 px-3 py-2.5 rounded-lg cursor-pointer transition-colors ${isChecked ? 'bg-amber-50' : 'hover:bg-gray-50'}`}>
                    <input type="checkbox" checked={isChecked} onChange={() => toggleSection(s.id)} className="w-4 h-4 rounded" />
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-medium truncate" style={{ color: '#163248' }}>{s.name}</div>
                      <div className="text-xs text-gray-500">{s.items?.length || 0} поз.</div>
                    </div>
                  </label>
                );
              })}
            </div>

            <div className="flex items-center gap-2 px-5 py-4 border-t flex-shrink-0">
              <button onClick={onClose} className="flex-1 px-4 py-2.5 bg-white border border-gray-200 hover:bg-gray-50 rounded-xl text-sm font-medium" style={{ color: '#163248' }}>
                Скасувати
              </button>
              <button onClick={handleExport} disabled={selected.size === 0}
                className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-white rounded-xl text-sm font-medium transition-colors ${selected.size === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-amber-500 hover:bg-amber-600'}`}>
                <Download className="w-4 h-4" />
                Експортувати{selected.size > 0 ? ` ${selected.size} розд.` : ''}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DirectoryExportModal;
